import React from "react";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const HeliReportColumn = ({ classes, ...props }) => (
  <Grid item className={classes.root} {...props} />
);

const styles = theme => ({
  root: {
    display: "flex",
    overflow: "hidden",
    alignItems: "center",
    padding: theme.spacing(1),
  },
});

export default compose(withStyles(styles))(HeliReportColumn);
